// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Colombia from '../_raw/flag/icon_flag_colombia.png';

export default () => <img src={Colombia} alt="Colombia" />;
